/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Service_Type_Jaw_PhysioInputs */

const en_service_type_jaw_physio = /** @type {(inputs: Service_Type_Jaw_PhysioInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`TMJ physiotherapy`)
};

const pl_service_type_jaw_physio = /** @type {(inputs: Service_Type_Jaw_PhysioInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Fizjoterapia stomatologiczna`)
};

/**
* | output |
* | --- |
* | "TMJ physiotherapy" |
*
* @param {Service_Type_Jaw_PhysioInputs} inputs
* @param {{ locale?: "en" | "pl" }} options
* @returns {LocalizedString}
*/
export const service_type_jaw_physio = /** @type {((inputs?: Service_Type_Jaw_PhysioInputs, options?: { locale?: "en" | "pl" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Service_Type_Jaw_PhysioInputs, { locale?: "en" | "pl" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "pl") return pl_service_type_jaw_physio(inputs)
	return en_service_type_jaw_physio(inputs)
});